import { FC } from "react";

interface ModalHeadingProps {
  title: string;
  description: string;
}

const ModalHeading: FC<ModalHeadingProps> = ({ description, title }) => {
  return (
    <div className=" space-y-4">
      <h4 className="text-base font-semibold  text-center">{title}</h4>
      <p className="text-color-sec-title text-center text-sm">{description}</p>
    </div>
  );
};

export default ModalHeading;
